import { defineStore } from 'pinia';
import { apolloClient } from '@/plugins/graphql';
import gql from 'graphql-tag';

const MAPBOX_TOKEN_QUERY = gql`
    query MapboxToken {
        mapbox {
            mapBoxToken
        }
    }
`;

export const useMapboxStore = defineStore('mapbox', {
    state: () => ({
        token: '' as string,
    }),
    actions: {
        async fetchToken() {
            try {
                const result = await apolloClient.query({ query: MAPBOX_TOKEN_QUERY });
                this.token = result.data?.mapbox?.mapBoxToken ?? import.meta.env.VITE_MAPBOX_ACCESS_TOKEN ?? '';
            } catch {
                this.token = import.meta.env.VITE_MAPBOX_ACCESS_TOKEN ?? '';
            }
        },
    },
});
